import axios, { AxiosResponse } from "axios";
import { useSession } from "next-auth/react";
import { PPUBalanceInfo } from "services/ppu/types";
import useSWR from "swr";
import { PlanMetadata } from "types/Plans";

export interface SubscriptionStats {
  quota: PlanMetadata;
  used: {
    requests: number;
    storage: string;
    storageFilecoin: string;
    webhookCount: number;
    projectCount: number;
    workspaceCount: number;
  };
  ppu: PPUBalanceInfo;
}

const key = "/api/customer/subscription-usage";

export const useSubscriptionStats = () => {
  const { data: session } = useSession();

  const { data, error } = useSWR<AxiosResponse<SubscriptionStats>>(
    session ? key : null,
    axios.get,
    {
      refreshInterval: 15000,
    }
  );

  return {
    stats: data?.data,
    isStatsLoading: !error && !data,
    isStatsError: error,
  };
};
